export const spacing = unit => `${unit * 4}px`
